<template>
  <md-card>
    <div>
      <md-card-header md-alignment="space-between">
        <h4 class="title">
          <md-icon>supervisor_account</md-icon>
          {{branchInfoData.branchNm}} ({{branchInfoData.branchId}})
          - 임원진 목록
        </h4>
      </md-card-header>
      <md-card-content>
        <div class="table-header-info">
          <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
          <div class="flex-div">
            <div class="inline-flex">
<!--              <md-button-->
<!--                class="md-default md-sm ux-wide-btn"-->
<!--                @click="showExecutiveListMode"-->
<!--              >-->
<!--                <md-icon>check</md-icon>-->
<!--                전체 교우 보기-->
<!--              </md-button>-->
              <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <grid ref="groupMemberList"
              :data="gridProps.data"
              :columns="gridProps.columns"
              :options="gridProps.options"
              :theme="gridProps.theme"
              :rowHeaders="gridProps.rowHeaders"
              :columnOptions="gridProps.columnOptions"
              :language="gridProps.lang"
              @response="response"
        ></grid>
      </md-card-content>
      <slot name="bottomRightArea"></slot>
    </div>
  </md-card>
</template>
<script>

import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";

import Swal from "sweetalert2";

import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

export default {
  name: "GroupExcutiveListComp",
  props: {
    viewListMode : {
      type: Number,
      default: 1
    }
  },
  components: {
    grid: Grid
  },

  created() {
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },

  watch : {
    'viewListMode' (n){
      if(n == 2){
        this.sendQuery();
      }
    }
  },

  data() {
    return {
      branchInfoData : {},
      gridProps: {},
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      }
    };
  },
  methods: {
    showExecutiveListMode (){
      this.$emit('update:viewListMode', 1);
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.groupMemberList, event, this.pagination);
    },

    sendQuery(branchInfo) {
      if(branchInfo && branchInfo.branchId){
        this.branchInfoData = branchInfo;
      }
      this.$refs.groupMemberList.invoke("readData", 1, {branchId : this.branchInfoData.branchId, expireDateYn : "Y"});
    },

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_BRANCH_ORG, false, this.pagination, ['rowNum','checkbox']);
      this.gridProps['el'] = this.$refs.groupMemberList;
      this.gridProps['columns']= [
          {header: '교우번호', name: 'memberNo',width: 'auto', sortable: true},
          {header: '교우명', name: 'memberHnm',width: 'auto', sortable: true},
          {header: '직책명', name: 'positionNm',width: 'auto', sortable: true},
          {header: '취임일', name: 'erectDate',width: 'auto', sortable: true,
            formatter(value) {
               return value.value != undefined && value.value.length == 8 ? formatter.getDateFormat(value.value) : value.value;
            }
          },
          {header: '기수', name: 'reign',width: 'auto', sortable: true},
          {header: '퇴임일', name: 'expireDate',width: 'auto', sortable: true,
            formatter(value) {
              return value.value != undefined && value.value.length == 8 ? formatter.getDateFormat(value.value) : value.value;
            }
          },
          {header: '비고', name: 'remark',width: 'auto'}
        ];
    },

    response(e) {
      let _this = this;
      if (this.instance == null) {
        this.instance = e.instance;
      }
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
        setTimeout(function () {
          let rows = _this.$refs.groupMemberList.invoke("getData");
          rows.forEach((obj)=>{
            if(obj.expireDate && obj.expireDate != ''){
              _this.$refs.groupMemberList.invoke("addRowClassName",obj.rowKey,'red');
            }
          });
        },100)
        this.$refs.groupMemberList.invoke("refreshLayout");
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
    },
    getSelectedMember(){
      return this.$refs.groupMemberList.invoke('getCheckedRows');
    }
  }
};
</script>

<style lang="css" scoped>

</style>